import { useContext, useEffect, useState } from 'react';
import './styles.css';
import DadosGerais from '../DadosGerais';
import Precos from '../Precos';
import UnidadeOperacao from '../UnidadeOperacao';
import InfoEstoque from '../InfoEstoque';
import InfoFiscais from '../InfoFiscais';
import { Printers } from '../Impressoras';
import { InfoSales } from '../InfoVenda';
import { notify, notifyError } from '../../../notify/notify-component';
import { ProdutoContext } from '../../../../context/product';
import Globals from '../../../../Globals.json';
import { useDispatch } from 'react-redux';
import { AppDispatch, useAppSelector } from '../../../../redux/store';
import LayoutProduct from '../../../data/LayoutProduct';
import { Tab, Tabs } from 'react-bootstrap';
import Layout from '../../../data/Layout';
import Complements from '../Complements';
import ModalBootstrap from '../../../data/Modal';
import api from '../../../../Services/api';
import Associated from '../Associados';
import { handleCloseModal } from '../../../../redux/features/product/product-slice';
import { ConfigProducts } from '../config';
import Loading from '../../../Loading/Loading';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';
import { useCreateData } from '../../../../apiQuery/useCreateData';
import { useUpdateData } from '../../../../apiQuery/useUpdateData';
import { queryClient } from '../../../../apiQuery/queryClient';
import { useFetchById } from '../../../../apiQuery/useFetchById';
import { useDeleteData } from '../../../../apiQuery/useDeleteData';

export default function FormProduto(props: any) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const dispatch = useDispatch<AppDispatch>();
  const createData = useCreateData(['products']);
  const updateData = useUpdateData(['products']);

  const { loading, configPizzaUuid } = useAppSelector(
    ({ productReducer }) => productReducer.value
  );
  const {
    currentAmount,
    status,
    image,
    idPdv,
    barcode,
    descriptionSale,
    descriptionPurchase,
    descriptionTouch,
    category,
    vendor,
    productType,
    sale,
    minSale,
    markup,
    markupPrice,
    coast,
    promotionalPrice,
    unit,
    typeOper,
    stock_uuid,
    minAmount,
    localStock,
    unitMeasureBuy,
    multiple,
    observation,
    taxProfile,
    stateOrigin,
    stateDestiny,
    types,
    origins,
    ncm,
    cest,
    cfop,
    customer,
    icms,
    ipi,
    cstReasons,
    pis,
    cofins,
    weight,
    aliquot,
    reduction,
    icmsAliquotDeferral,
    icmsCredit,
    aliquotIpi,
    aliquotPis,
    aliquotCofins,
    mva,
    xdRequestQty,
    xdRequestPriceWhenZero,
    xdBalanceQty,
    xdOrderGrouped,
    xdBillGroup,
    xdAddTips,
    xdExcludeMinimumConsumption,
    xdBook,
    xdFollowItem,
    xdPrinters,
    cleanInputs,
    handleEdit,
    handleDuplicate,
    handleValidete,
    selfService,
    categoriesList,
    setValidLocalStock,
    associatedComplement,
    ncm_origin,
    visible_falimix,
    visible_autoplu,
    visible_delivery,
    visible_digital_menu,
    visible_online,
    visible_xd_orders,
  } = useContext(ProdutoContext);

  const [key, setKey] = useState('info-sales');
  const [modalDel, setModalDel] = useState<boolean>(false);
  const [uuidProduct, setUuidProduct] = useState<string>('');
  const [fetchLoading, setFetchLoading] = useState<boolean>(false);
  
  const {
    data: productByUuid,
    isLoading: isLoadingProductById,
    isError: isErrorProductById,
    refetch,
  } = useFetchById<any>(
    'products',
    `${Globals.api.products}`,
    props.produto?.uuid,
    {
      queryParams: {
        append: 'stock_qty',
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        'filter[is_active]': true,
      },
    }
  );
  
  const {
    data: categories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
  } = useQueryFetchPages<any>(
    ['category'],
    `${Globals.api.categoriesCompleted}/minified`,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
        'filter[is_active]': true,
      },
    }
  );

  const handleSave = async () => {
  setFetchLoading(true);
  
  const valid = handleValidete();

  if (valid === false) {
    console.group('🔴 VALIDAÇÃO FALHOU - Campos obrigatórios faltando:');

    if (!idPdv) console.error('❌ Código (PDV) está vazio');
    if (!descriptionSale) console.error('❌ Descrição de Venda está vazio');
    if (!category) console.error('❌ Categoria está vazia');

    // ✅ AJUSTE: productType pode ser 0 (zero é válido)
    if (productType === null || productType === undefined) {
      console.error('❌ Tipo de Produto está vazio');
    }

    if (!sale || parseFloat(sale) <= 0) console.error('❌ Preço de Venda inválido:', sale);
    if (!minSale) console.error('❌ Preço de Venda Mínimo está vazio');

    // ✅ AJUSTE: coast pode ser 0 (zero é válido para produtos sem custo)
    if (coast === null || coast === undefined || coast === '') {
      console.error('❌ Preço de Custo inválido:', coast);
    }

    if (!unit) console.error('❌ Unidade de Medida está vazia');
    if (!ncm) console.error('❌ NCM está vazio');
    if (selfService && !cstReasons) console.error('❌ CST/Motivo está vazio (obrigatório para self-service)');
    if (!cfop) console.error('❌ CFOP está vazio');
    if (!icms) console.error('❌ ICMS está vazio');
    if (!aliquot) console.error('❌ Alíquota ICMS está vazia');
    if (!ipi) console.error('❌ IPI está vazio');
    if (!aliquotIpi) console.error('❌ Alíquota IPI está vazia');
    if (!pis) console.error('❌ PIS está vazio');
    if (!cofins) console.error('❌ COFINS está vazio');
    if (!aliquotPis) console.error('❌ Alíquota PIS está vazia');

    if (typeOper !== 1) {
      if (!currentAmount || parseFloat(currentAmount) < 0) {
        console.error('❌ Quantidade Atual inválida:', currentAmount);
      }
      if (!localStock) console.error('❌ Local de Estoque está vazio');
    }

    console.log('📊 Valores atuais:', {
      idPdv,
      descriptionSale,
      category,
      productType, // Vai mostrar 0
      sale,
      minSale,
      coast, // Vai mostrar 0
      unit,
      ncm,
      cstReasons,
      cfop,
      icms,
      aliquot,
      ipi,
      aliquotIpi,
      pis,
      cofins,
      aliquotPis,
      currentAmount,
      localStock,
      typeOper,
      selfService,
    });

    console.groupEnd();
    
    notifyError('Por favor preencha todos os campos obrigatórios');
    setFetchLoading(false);
    
    setTimeout(() => {
      const invalidSelector = '[data-invalid="true"], .is-invalid, [aria-invalid="true"]';
      const firstInvalidField = document.querySelector(invalidSelector) as HTMLElement | null;
      if (firstInvalidField) {
        console.log('🎯 Primeiro campo inválido encontrado:', firstInvalidField);

        // Se o campo estiver dentro de uma aba, alternar para a aba correta
        const tabWrapper = firstInvalidField.closest('[data-tab]') as HTMLElement | null;
        const tabKey = tabWrapper?.getAttribute('data-tab');
        if (tabKey && tabKey !== key) {
          setKey(tabKey);
          // Aguardar renderização da aba antes de fazer o scroll
          setTimeout(() => {
            firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 50);
        }

        // Coletar e exibir rótulos (labels) ou nomes dos campos inválidos para facilitar o entendimento
        const getLabelFromEl = (el: Element): string | undefined => {
          const he = el as HTMLElement;
          // 1) data-label explícito
          const dataLabel = he.getAttribute('data-label');
          if (dataLabel) return dataLabel.trim();

          // 2) Estrutura comum dos inputs customizados: label como irmão anterior
          //   Ex.: <div class="label">...</div> <div class="select" ...> ...
          const selectWrapper = he.closest('.select');
          const prevLabelFromSelect = selectWrapper?.previousElementSibling;
          if (prevLabelFromSelect && prevLabelFromSelect.classList.contains('label')) {
            return prevLabelFromSelect.textContent?.trim();
          }

          const prevSibling = he.previousElementSibling;
          if (prevSibling && prevSibling.classList.contains('label')) {
            return prevSibling.textContent?.trim();
          }

          // 3) Procura por label no mesmo grupo/contêiner
          const group = he.closest('.form-group') || he.parentElement;
          const labelInGroup = group?.querySelector('.label') as HTMLElement | null;
          if (labelInGroup) return labelInGroup.textContent?.trim();

          // 4) Label nativo associado via htmlFor
          const idAttr = he.getAttribute('id');
          if (idAttr) {
            const forLabel = document.querySelector(`label[for="${idAttr}"]`);
            if (forLabel) return forLabel.textContent?.trim() || undefined;
          }

          // 5) Atributos comuns
          const ariaLabel = he.getAttribute('aria-label');
          if (ariaLabel) return ariaLabel.trim();
          const nameAttr = he.getAttribute('name');
          if (nameAttr) return nameAttr.trim();
          const placeholder = (he as HTMLInputElement).placeholder;
          if (placeholder) return placeholder.trim();

          // 6) Fallback: tagName
          return he.tagName;
        };

        const allInvalid = Array.from(document.querySelectorAll(invalidSelector));
        const fieldsData = allInvalid.map((el) => {
          const he = el as HTMLElement;
          const label = getLabelFromEl(el);
          const tabWrap = he.closest('[data-tab]') as HTMLElement | null;
          const tabKeyFound = tabWrap?.getAttribute('data-tab');
          const origin = he.matches('[data-invalid="true"]')
            ? 'data-invalid'
            : he.matches('.is-invalid')
            ? 'is-invalid'
            : he.matches('[aria-invalid="true"]')
            ? 'aria-invalid'
            : 'desconhecida';
          return {
            campo: label || he.getAttribute('name') || he.tagName,
            aba: tabKeyFound || key || 'desconhecida',
            origin,
          };
        });

        if (fieldsData.length) {
          console.group('📌 Campos inválidos detectados');
          console.table(fieldsData.map(({ campo, aba, origin }) => ({ Campo: campo, Aba: aba, Origem: origin })));
          console.groupEnd();
        }

        if (!tabKey) {
          firstInvalidField.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      } else {
        console.warn('⚠️ Nenhum campo inválido foi encontrado via [data-invalid], .is-invalid ou [aria-invalid]');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 100);
    
    return;
  }

    if (!localStock) {
      notifyError('Por favor preencha Local de estoque.');
      setValidLocalStock(true);
      setFetchLoading(false);
      
      // Scroll para o campo de estoque
      setTimeout(() => {
        const stockField = document.querySelector('[name="localStock"]') || 
                          document.querySelector('[data-field="localStock"]');
        if (stockField) {
          stockField.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
        } else {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      }, 100);
      
      return;
    }

    const data = {
      uuid: props.editando && props?.produto?.uuid,
      product_type_id: productType,
      ...(idPdv && { id_pdv: idPdv.toString() }),
      ...(category &&
        category !== props?.id_pdv_category && {
          id_pdv_category: category?.toString(),
        }),
      ...(storeMe?.storeActive?.id && { store_id: storeMe?.storeActive?.id }),
      ...(vendor && { vendor_id: vendor }),
      ...(typeOper && { product_purpose_id: typeOper }),
      ...(unit && { sale_measure_unit_id: unit }),
      ...(unitMeasureBuy && { stock_measure_unit_id: unitMeasureBuy }),
      ...(taxProfile && { tax_profile_id: taxProfile }),
      ...(types && { tax_invoice_type_id: types }),
      ...(origins && { cst_origin_id: origins }),
      ...(ncm && { ncm_id: ncm }),
      ...(cfop && { cfop_id: cfop }),
      ...(cest && { cest_id: cest }),
      ...(icms && { cst_icms_id: icms }),
      ...(stateOrigin && { icms_origin_state_id: stateOrigin }),
      ...(stateDestiny && { icms_destiny_state_id: stateDestiny }),
      ...(customer && { icms_customer_type_id: customer }),
      ...(ipi && { cst_ipi_id: ipi }),
      ...(cstReasons && { cst_ipi_reason_id: cstReasons }),
      ...(pis && { cst_pis_id: pis }),
      ...(cofins && { cst_cofins_id: cofins }),
      ...(barcode && { barcode: barcode }),
      ...(descriptionSale && { sale_name: descriptionSale }),
      ...(descriptionPurchase && { purchase_name: descriptionPurchase }),
      ...(descriptionTouch && { touch_name: descriptionTouch }),
      ...(sale && { sale_price: parseFloat(sale) }),
      ...(coast && { cost_price: parseFloat(coast) }),
      ...(minSale && { sale_minimal_price: parseFloat(minSale) }),
      promotional_price: parseFloat(promotionalPrice || '0'),
      ...(ncm_origin && { ncm_origin: ncm_origin }),

      ...(!props.editando && stock_uuid && { stock_uuid: stock_uuid }),
      ...(!props.editando && { stock_movement_type_id: 49 }),
      ...(!props.editando && { situation_id: 1 }),

      ...(minAmount && { stock_minimal_qty: parseFloat(minAmount) }),
      stock_qty: parseFloat(currentAmount ? currentAmount : '0'),

      ...(observation && { stock_reference: observation }),
      ...(localStock && { stock_local_id: localStock }),

      ...(multiple && { sale_measure_unit_multiplier: parseFloat(multiple) }),
      ...(weight && { tax_weight: parseFloat(weight) }),
      ...(aliquot && { icms_aliquot: parseFloat(aliquot) }),
      ...(icmsCredit && { icms_credit: parseFloat(icmsCredit) }),
      ...(mva && { icms_mva: parseFloat(mva) }),
      ...(reduction && { icms_base_calc_reduction: parseFloat(reduction) }),
      ...(icmsAliquotDeferral && {
        icms_aliquot_deferral: parseFloat(icmsAliquotDeferral),
      }),
      ...(aliquotIpi && { ipi_aliquot: parseFloat(aliquotIpi) }),
      ...(aliquotPis && { pis_aliquot: parseFloat(aliquotPis) }),
      ...(aliquotCofins && { cofins_aliquot: parseFloat(aliquotCofins) }),
      is_active: status,
      ...(markupPrice && { markup_value: parseFloat(markupPrice) }),
      ...(markup && { markup_percentil: parseFloat(markup) }),

      ...(image && !isUrl(image) && { image: image }),

      ...(xdRequestQty !== undefined && { xd_request_qty: xdRequestQty }),
      ...(xdRequestPriceWhenZero !== undefined && {
        xd_request_price_when_zero: xdRequestPriceWhenZero,
      }),
      ...(xdBalanceQty !== undefined && { xd_balance_qty: xdBalanceQty }),
      ...(xdOrderGrouped !== undefined && { xd_order_grouped: xdOrderGrouped }),
      ...(xdBillGroup !== undefined && { xd_bill_group: xdBillGroup }),
      ...(xdAddTips !== undefined && { xd_add_tips: xdAddTips }),
      ...(xdExcludeMinimumConsumption !== undefined && {
        xd_exclude_minimum_consumption: xdExcludeMinimumConsumption,
      }),
      ...(xdBook !== undefined && { xd_book: xdBook }),
      ...(xdPrinters && { xd_printers: xdPrinters }),
      ...(xdFollowItem !== undefined && { xd_follow_item: xdFollowItem }),
      self_service: selfService,
      product_complements: completmentProduct(categoriesList),
      product_associateds: completmentProduct(associatedComplement),
      visible_falimix,
      visible_autoplu,
      visible_delivery,
      visible_digital_menu,
      visible_online,
      visible_xd_orders,
    };

    if (data.uuid) {
      updateData.mutate(
        {
          endpoint: Globals.api.products,
          id: data.uuid,
          payload: data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: ['products'],
              exact: false, // Invalida todas as queries que começam com 'products'
            });
            notify('Produto atualizado com sucesso!');
            handleCancel();
            cleanInputs();
            setFetchLoading(false);
          },
          onError: (error: any) => {
            console.error('Erro ao atualizar produto:', error);
            notifyError('Erro ao atualizar produto. Tente novamente.');
            setFetchLoading(false);
          },
        }
      );
    } else {
      createData.mutate(
        {
          endpoint: Globals.api.products,
          payload: data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: ['products'],
              refetchType: 'active',
            });
            notify('Produto criado com sucesso!');
            setFetchLoading(false);
            cleanInputs();
            handleCancel();
          },
          onError: (error: any) => {
            console.error('Erro ao criar produto:', error);
            notifyError('Erro ao criar produto. Tente novamente.');
            setFetchLoading(false);
          },
        }
      );
    }
  };

  const isUrl = (str: string) => {
    const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return urlRegex.test(str);
  };

  const completmentProduct = (list: any) => {
    if (!list || list.length === 0) return [];
    
    const newList = [];
    for (let index = 0; index < list.length; index++) {
      if (list[index]?.id) {
        newList.push({
          product_id: list[index].id,
        });
      }
    }
    return newList;
  };

  const handleModalDelete = (row: any) => {
    setModalDel(true);
    setUuidProduct(row.uuid);
  };
  
  const deleteData = useDeleteData(['products']);

  const handleDelete = async (uuid: string) => {
    deleteData.mutate(
      {
        endpoint: Globals.api.products,
        id: uuidProduct,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey[0] === 'products',
          });
          notify('Produto excluído com sucesso!');
          setModalDel(false);
          cleanInputs();
          handleCancel();
        },
        onError: (error: any) => {
          console.error('Erro ao excluir produto:', error);
          notifyError('Erro ao excluir produto. Tente novamente.');
          setModalDel(false);
        },
      }
    );
  };

  const handleCancel = () => {
    props.onCancelAction();
    dispatch(handleCloseModal());
    cleanInputs();
  };

  const {
    data: ncms,
    isLoading: isLoadingNcms,
    isError: isErrorNcms,
  } = useQueryFetchPages<any>(['ncms'], `${Globals.api.taxes}/ncms`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
      'filter[is_active]': true,
    },
  });

  useEffect(() => {
    if (props.editando && productByUuid?.data) {
      handleEdit(productByUuid.data);
    }
    if (props.duplicar && productByUuid?.data) {
      handleDuplicate(productByUuid.data);
    }
  }, [productByUuid?.data, props.duplicar, props.editando]);

  if (isLoadingProductById && (props.editando || props.duplicar)) {
    return <Loading />;
  }

  return (
    <>
      <ModalBootstrap
        state={modalDel}
        setState={setModalDel}
        text={'Tem certeza de que deseja excluir este produto?'}
        handleAction={handleDelete}
      />
      <div className="mb-4">
        <LayoutProduct
          isEditable={props.editando}
          onClickSave={handleSave}
          onClickEdit={handleSave}
          onClickCancel={handleCancel}
          handleDelete={() => handleModalDelete(props?.produto)}
          isLoading={fetchLoading || loading}
        >
          <DadosGerais isEdit={props.editando} produtoEdite={props?.produto} />

          <Precos />

          <UnidadeOperacao />

          <InfoEstoque isEdit={props.editando} isDupli={props.duplicar} />

          <InfoFiscais
            isEdit={props.produto}
            isDupli={props.produto}
            product={props?.produto || props?.produto}
          />

          <Layout title="">
            <Tabs
              defaultActiveKey="info-sales"
              className="mt-2"
              activeKey={key}
              onSelect={(k: any) => setKey(k)}
            >
              <Tab eventKey="info-sales" title="Informações de Venda">
                <div data-tab="info-sales"><InfoSales /></div>
              </Tab>
              <Tab eventKey="config" title="Configurações">
                <div data-tab="config"><ConfigProducts /></div>
              </Tab>
              <Tab eventKey="print" title="Impressoras">
                <div data-tab="print"><Printers /></div>
              </Tab>
              <Tab eventKey="complement" title="Observações">
                <div data-tab="complement">
                  <Complements
                    isEditable={props.editando}
                    isDuplicate={props.duplicar}
                  />
                </div>
              </Tab>
              <Tab eventKey="associated" title="Extras">
                <div data-tab="associated">
                  <Associated
                    isEditable={props.editando}
                    isDuplicate={props.duplicar}
                  />
                </div>
              </Tab>
            </Tabs>
          </Layout>
        </LayoutProduct>
      </div>
      {(loading || fetchLoading) && <Loading />}
    </>
  );
}